import { feedItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function FeedGrid() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <SectionHeading
          id="feed"
          kicker="02 / FEED"
          title="翻车合集"
          desc="一次改版、一段付费体验、一桩没有回应的指控，都被拆成独立的档案卡片。每张封面背后，是一整段可以被反复翻看的记录。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-14 md:grid-cols-2">
          {feedItems.map((item, index) => (
            <article
              key={item.id}
              data-reveal
              className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
                index === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div
                className={`relative w-full overflow-hidden ${
                  index === 0 ? 'h-64 md:h-80' : 'h-52 md:h-60'
                }`}
              >
                <img
                  src={item.image}
                  alt={`${item.title} 封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-800 backdrop-blur">
                  {item.category}
                </span>
              </div>

              <div className={`flex flex-1 flex-col p-5 md:p-6 ${index === 0 ? 'md:max-w-3xl' : ''}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{item.author}</span>
                  <span className="h-1 w-1 rounded-full bg-foreground-300" />
                  <span>{item.date}</span>
                  <span className="h-1 w-1 rounded-full bg-foreground-300" />
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {item.readTime}
                  </span>
                </div>

                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{item.excerpt}</p>

                <a
                  href="#ranking"
                  className="mt-5 inline-flex items-center gap-2 self-start text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  阅读这一篇
                  <i className="ri-arrow-right-line text-base" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}